"use strict";

import { Box } from '@autoguru/overdrive';
import clsx from 'clsx';
import * as styles from './HeaderLayout.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeaderLayout = _ref => {
  let {
    children,
    safePaddings = false,
    transparent = false,
    floating = false,
    className = ''
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    is: "header",
    display: "flex",
    position: floating ? 'absolute' : 'relative',
    width: "full",
    justifyContent: "spaceBetween",
    alignItems: "center",
    backgroundColour: transparent ? 'transparent' : 'white',
    overflow: "hidden",
    paddingX: "4",
    className: clsx(styles.root, className, {
      [styles.shadow]: !transparent,
      [styles.safePaddings]: safePaddings,
      [styles.floating]: floating
    }),
    children: children
  });
};